import React from 'react'

import PropTypes from 'prop-types'

import { Link, Typography } from '@material-ui/core'

import { useAppConfig } from 'signup/config/hooks'
import {
  SUPPORT_URL_BECOMING_SUPPLIER,
  SUPPORT_URL_PACKAGING_AND_SHIPPING,
  SUPPORT_URL_RETAILER_TERMS,
  SUPPORT_URL_SUPPLIER_RETURN_POLICY,
  SUPPORT_URL_SUPPLIER_TERMS,
} from 'signup/constants'

import style from './LegalNotice.module.scss'

export const LEGAL_NOTICE_RETAILER_SIGN_UP = 'retailerSignUp'
export const LEGAL_NOTICE_SUPPLIER_SIGN_UP = 'supplierSignUp'
export const LEGAL_NOTICE_SIGN_IN = 'signIn'

const LegalLink = ({ href, children }) => (
  <Link href={href} target="_blank" rel="noopener noreferrer">
    {children}
  </Link>
)

LegalLink.propTypes = {
  href: PropTypes.string,
  children: PropTypes.string.isRequired,
}

const LegalNotice = ({ type, ...rest }) => {
  const { termsUrl, privacyPolicyUrl } = useAppConfig()

  const termsLink = <LegalLink href={termsUrl}>Modalyst Terms of Service</LegalLink>
  const privacyLink = <LegalLink href={privacyPolicyUrl}>Modalyst Privacy Policy</LegalLink>

  return (
    <Typography
      variant="body2"
      color="textSecondary"
      className={style.LegalNotice}
      {...rest}
      align="center"
    >
      {type === LEGAL_NOTICE_SIGN_IN && (
        <>
          By continuing, you agree to the {termsLink} and you acknowledge the {privacyLink}.
        </>
      )}
      {type === LEGAL_NOTICE_RETAILER_SIGN_UP && (
        <>
          By completing the sign-up, you agree to the {termsLink}, the{' '}
          <LegalLink href={SUPPORT_URL_RETAILER_TERMS}>
            Dropshipping T&amp;Cs for Retailers
          </LegalLink>{' '}
          and you acknowledge the {privacyLink}.
        </>
      )}
      {type === LEGAL_NOTICE_SUPPLIER_SIGN_UP && (
        <>
          By completing the sign-up, you agree to the {termsLink},{' '}
          <LegalLink href={SUPPORT_URL_SUPPLIER_TERMS}>
            Modalyst Suppliers Terms and Conditions
          </LegalLink>
          , the{' '}
          <LegalLink href={SUPPORT_URL_PACKAGING_AND_SHIPPING}>
            Modalyst Packaging and Shipping Policies
          </LegalLink>
          , the terms for{' '}
          <LegalLink href={SUPPORT_URL_BECOMING_SUPPLIER}>
            Becoming a Supplier on Modalyst
          </LegalLink>
          , and the{' '}
          <LegalLink href={SUPPORT_URL_SUPPLIER_RETURN_POLICY}>
            Modalyst Return Policy for Suppliers
          </LegalLink>
          ; and you acknowledge the {privacyLink}.
        </>
      )}
    </Typography>
  )
}

LegalNotice.propTypes = {
  type: PropTypes.oneOf([
    LEGAL_NOTICE_RETAILER_SIGN_UP,
    LEGAL_NOTICE_SUPPLIER_SIGN_UP,
    LEGAL_NOTICE_SIGN_IN,
  ]).isRequired,
}

export default LegalNotice
